import { Component, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { FieldConfig } from '../../../_models/field.interface';
@Component({
  selector: 'app-uploadFilesGeneric',
  template: `
  <div
      [formGroup]="group"
      [ngStyle]="field.styleDivPrincipal ? field.styleDivPrincipal() : null"
      *ngIf="field.visible != null ? (!field.visible ? false : true) : true"
    >
  <div class="divBotoes">
  <label for="file-upload" class="cs_botao" style='background-color: #461F1A; color: #F4B241; font-weight: bold; padding: 8px 20px 8px 20px'>Anexar Arquivos</label>
  <input type="file" (change)="field.selectFiles($event)" id="file-upload" accept="image/png, image/jpeg, application/pdf" hidden />
</div>

<div class="divPrincipalAnexo">
<div *ngFor="let arquivo of field.arquivos" class="divAnexos">
  <button type="submit" class="close " (click)="field.removerArquivo(arquivo)">
    <span>&times;</span>
  </button>
  <img [src]="field.transform(arquivo.base64, arquivo.tipoArquivo)" class="imgUpload" *ngIf="arquivo.base64 != null">
  <span class="cs_label">{{arquivo.nome}}</span>
</div>
</div>
</div>
  `,
  styleUrls: ['./upload-files-generic.component.scss'],
})
export class UploadFilesGenericComponent implements OnInit {
  field: FieldConfig;
  group: UntypedFormGroup;

  constructor() {}
  ngOnInit() {}
}
